<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true"
                >skip_previous</md-icon
              >Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Verified Gross Mass (VGM)</b-navbar-brand>
        </b-navbar>
        <banner-component
          :allModuleIdBanner="this.ALLFclData[0].allModuleId ? this.ALLFclData[0].allModuleId : ''"
          :jobSeriesBanner="this.ALLFclData[0].ccImportSeries ? this.ALLFclData[0].ccImportSeries :''"
          :bannerClientName="this.ALLFclData[0].exporterName ? this.ALLFclData[0].exporterName : ''"
          iconId="fa fa-ship"
        />
        <b-card class="formCard">
          <b-card-text>
            <!-- <b-card style="height:90px !important" class="HeaderMastBanner">
              <md-layout gutter>
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <b>Assignment No. : {{ALLFclData[0].ccImportSeries}}</b>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="25">
                  <b>Job Type : {{ALLFclData[0].jobType}}</b>
                </md-layout>
                <md-layout md-flex="40">
                  <md-layout md-flex="100">
                    <b>Shipping Line : {{ALLFclData[0].shippingLine}}</b>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout gutter>
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <b>Importer Name : {{ALLFclData[0].Importer}}</b>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="25">
                  <b>FF Activity : {{ALLFclData[0].containerInfo}}</b>
                </md-layout>
                <md-layout md-flex="40">
                  <md-layout md-flex="100"></md-layout>
                </md-layout>
              </md-layout>
              <md-layout gutter>
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <b>
                      Exporter Name : {{ALLFclData[0].exporterName}}
                      <br>
                    </b>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="25"></md-layout>
                <md-layout md-flex="40">
                  <md-layout md-flex="100"></md-layout>
                </md-layout>
              </md-layout>
            </b-card> -->
            <div v-if="containerNoList.length > 0 || vgmModel.ccVgmId != ''">
              <md-layout md-gutter>
                <md-layout md-flex="100">
                  <md-layout md-flex="100">
                    <label>Shipper Name</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="clientName"
                      name="clientName"
                      v-model="vgmModel.clientName"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="100">
                  <md-layout md-flex="100">
                    <label>Client Registration / License No.</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="clientRegistrationNo"
                      name="clientRegistrationNo"
                      v-model="vgmModel.clientRegistrationNo"
                    ></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!vgmModel.clientRegistrationNo">{{
                    errorVgmList.clientRegistrationNo
                  }}</span>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="100">
                  <md-layout md-flex="100">
                    <label
                      >Name and Registration of official of the client
                      authorized to sign document</label
                    >
                    <b-form-input :formatter="capitalizeAll"
                      id="nameRegistrationOfficial"
                      name="nameRegistrationOfficial"
                      v-model="vgmModel.nameRegistrationOfficial"
                    ></b-form-input>
                  </md-layout>
                  <span
                    class="error"
                    v-if="!vgmModel.nameRegistrationOfficial"
                    >{{ errorVgmList.nameRegistrationOfficial }}</span
                  >
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="100">
                  <md-layout md-flex="100">
                    <label
                      >24*7 contact No. of authorized official of client</label
                    >
                    <b-form-input :formatter="capitalizeAll"
                      id="officialContactNo"
                      name="officialContactNo"
                      v-model="vgmModel.officialContactNo"
                    ></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!vgmModel.officialContactNo">{{
                    errorVgmList.officialContactNo
                  }}</span>
                </md-layout>
              </md-layout>

              <md-layout md-gutter class="labelMargtop">
                <md-layout md-flex="100">
                  <label for="containerNo" v-if="vgmModel.ccVgmId == ''"
                    >Container No</label
                  >
                  <model-list-select
                    v-if="vgmModel.ccVgmId == ''"
                    :list="containerNoList"
                    v-model="vgmModel.ccContanerId"
                    option-value="uniqueContainerId"
                    option-text="containerNo"
                    placeholder="Select Container No"
                  ></model-list-select>
                  <md-layout md-flex="100" v-else>
                    <label for="containerNo">Container No</label>
                    <b-form-input :formatter="capitalizeAll"
                      v-model="vgmModel.containerNo"
                      disabled
                    ></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!vgmModel.ccContanerId">{{
                    errorVgmList.ccContanerId
                  }}</span>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="100">
                  <label for="containerTypeId"
                    >Container Size (TEU/FEU/Other)</label
                  >
                  <model-list-select
                    :list="ContainerTypeList"
                    v-model="vgmModel.containerTypeId"
                    option-value="containerTypeId"
                    option-text="containerType"
                    placeholder="Select Container Type/Size"
                    :isDisabled="true"
                  ></model-list-select>
                </md-layout>
              </md-layout>

              <md-layout md-gutter class="gutr">
                <md-layout md-flex="100">
                  <md-layout md-flex="100">
                    <label>Verfiied Gross mass of container(Method-1/2)</label>
                    <model-list-select
                      :list="massWeightList"
                      v-model="vgmModel.verifiedConGrossMass"
                      option-value="mwV"
                      option-text="mwT"
                      placeholder="Select "
                    ></model-list-select>
                  </md-layout>
                  <span class="error" v-if="!vgmModel.verifiedConGrossMass">{{
                    errorVgmList.verifiedConGrossMass
                  }}</span>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="100">
                  <md-layout md-flex="100">
                    <label
                      >Maximum permissible weight of container as per the CSC
                      plate</label
                    >
                    <b-form-input :formatter="capitalizeAll"
                      type="number"
                      id="maxPermissibleWeight"
                      name="maxPermissibleWeight"
                      v-model="vgmModel.maxPermissibleWeight"
                    ></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!vgmModel.maxPermissibleWeight">{{
                    errorVgmList.maxPermissibleWeight
                  }}</span>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="100">
                  <md-layout md-flex="100">
                    <label>VGM Weight</label>
                    <b-form-input :formatter="capitalizeAll"
                      type="number"
                      :disabled="
                        vgmModel.maxPermissibleWeight != '' ? false : true
                      "
                      id="vgmWeight"
                      name="vgmWeight"
                      v-model="vgmModel.vgmWeight"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>

              <md-layout md-gutter class="labelMargtop">
                <md-layout md-flex="25">
                  <label>Date & time of Weighing</label>
                  <date-picker
                    lang="en"
                    name="weighingDate"
                    id="weighingDate"
                    type="datetime"
                    format="YYYY-MM-DD hh:mm a"
                    :minute-step="1"
                    v-model="vgmModel.weighingDate"
                  ></date-picker>
                  <span class="error" v-if="!vgmModel.weighingDate">{{
                    errorVgmList.weighingDate
                  }}</span>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="100">
                  <md-layout md-flex="100">
                    <label>Weighing Slip No</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="weighingSlipNo"
                      name="weighingSlipNo"
                      v-model="vgmModel.weighingSlipNo"
                    ></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!vgmModel.weighingSlipNo">{{
                    errorVgmList.weighingSlipNo
                  }}</span>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="100">
                  <md-layout md-flex="100">
                    <label>Weighbridge Registration No.</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="weighbridgeRegNo"
                      name="weighbridgeRegNo"
                      v-model="vgmModel.weighbridgeRegNo"
                    ></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!vgmModel.weighbridgeRegNo">{{
                    errorVgmList.weighbridgeRegNo
                  }}</span>
                </md-layout>
              </md-layout>

              <md-layout md-gutter class="gutr">
                <md-layout md-flex="100">
                  <md-layout md-flex="100">
                    <label>Weighbridge Address</label>
                    <b-form-textarea :formatter="capitalizeAll"
                      id="weighbridgeAddress"
                      name="weighbridgeAddress"
                      v-model="vgmModel.weighbridgeAddress"
                    ></b-form-textarea>
                  </md-layout>
                  <span class="error" v-if="!vgmModel.weighbridgeAddress">{{
                    errorVgmList.weighbridgeAddress
                  }}</span>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="labelMargtop">
                <md-layout md-flex="15">
                  <b-button
                    style="margin: 0px"
                    variant="info"
                    size="sm"
                    @click="addAdditional"
                    >Add More Fields</b-button
                  >
                </md-layout>
              </md-layout>
              <md-layout
                gutter
                v-for="(item, index) in vgmModel.additionalDetails"
                :key="index"
                class="labelMargtop"
              >
                <md-layout md-flex="35">
                  <label>Enter Label</label>

                  <b-form-input :formatter="capitalizeAll"
                    v-model="vgmModel.additionalDetails[index].additionalLabel"
                  ></b-form-input>
                </md-layout>
                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="50">
                  <label>Enter Value</label>

                  <b-form-input :formatter="capitalizeAll"
                    v-model="vgmModel.additionalDetails[index].additionalValue"
                  ></b-form-input>
                </md-layout>
                <md-layout md-flex="10" style="margin-top: 4%">
                  <md-button
                    class="md-icon-button md-raised md-dense"
                    @click="removeNotify(index)"
                    style="min-height: 20px; height: 20px; width: 20px"
                  >
                    <md-icon>close</md-icon>
                  </md-button>
                </md-layout>
              </md-layout>

              <md-layout md-gutter class="labelMargtop">
                <md-layout md-flex="65">
                  <!-- <h4 style="padding:0px;margin:0px"></h4> -->
                  <label for="autoCommodity">Commodity</label>
                  <model-list-select
                    :list="commodityList"
                    v-model="ffExoprtDetail.commodityId"
                    option-value="commodityId"
                    option-text="itemDescription"
                    placeholder="Select Commodity"
                    :isDisabled="true"
                  ></model-list-select>
                </md-layout>
                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="30">
                  <md-layout md-flex="100">
                    <label for="commodityType">Commodity Type</label>

                    <b-form-input :formatter="capitalizeAll"
                      id="commodityType"
                      name="commodityType"
                      disabled
                      v-model="ffExoprtDetail.commodityType"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="labelMargtop">
                <md-layout md-flex="100">
                  <md-layout md-flex="100">
                    <label for="itemDescription">Item Description</label>

                    <b-form-textarea :formatter="capitalizeAll"
                      id="itemDescription"
                      name="itemDescription"
                      disabled
                      v-model="ffExoprtDetail.itemDescription"
                    ></b-form-textarea>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout
                md-gutter
                class="gutr"
                v-if="ffExoprtDetail.commodityType == 'Hazardous'"
              >
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>IMDG Class</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="IMDGClass"
                      name="IMDGClass"
                      v-model="ffExoprtDetail.IMDGClass"
                      disabled
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>UN Number</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="UNNumber"
                      name="UNNumber"
                      v-model="ffExoprtDetail.UNNumber"
                      disabled
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>Packing Code</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="packingCode"
                      name="packingCode"
                      v-model="ffExoprtDetail.packingCode"
                      disabled
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>

              <md-layout md-gutter class="gutr">
                <md-layout md-flex="30">
                  <b-button
                    class="mt-3"
                    variant="primary"
                    @click="addVGM"
                    id="addButtonLoader1"
                    >{{
                      vgmModel.ccVgmId != ""
                        ? "Update & Submit"
                        : "Save & Submit"
                    }}</b-button
                  >
                  <md-spinner
                    md-indeterminate
                    id="loader1"
                    style="display: none"
                  ></md-spinner>
                </md-layout>
              </md-layout>
            </div>

            <div class="mt-3" v-if="vgmArrayList.length > 0">
              <h5>
                <b-badge>VGM Details</b-badge>
              </h5>

              <!-- /.box-header -->
              <div class="box-body">
                <table id="poTablefdfdf" class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sr No.</th>
                      <th>Shipper Name</th>
                      <th>ContainerNo</th>
                      <th>Container Type</th>

                      <th>Edit</th>
                      <th>Print</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in vgmArrayList" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.clientName }}</td>
                      <td>{{ item.containerNo }}</td>
                      <td>{{ item.containerType }}</td>
                      <td>
                        <md-button
                          class="md-icon-button md-raised md-dense"
                          @click="viewEdit(item)"
                        >
                          <md-icon>edit</md-icon>
                        </md-button>
                      </td>
                      <td>
                        <md-button
                          class="md-icon-button md-raised md-dense"
                          @click="Print(item.uploadVgm)"
                        >
                          <md-icon>print</md-icon>
                        </md-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.box-body -->
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPopMaxPer"
      @close="clearPermisibleWgt"
    ></md-dialog-alert>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop6"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import BannerComponent from "../allModuleForm/bannerComponent.vue";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";

export default {
  beforeMount() {
    if (
      globalPermissionStatus("Custom Clearance") &&
      this.$sessionsStorage.get("editCcImportId") != undefined &&
      this.$sessionsStorage.get("editCcImportId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/CCImport/CCExportEntry");

      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  data() {
    return {
      docURL: URL_BASE_DOC,
      isLoading: false,
      containerNoName: [],
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      massWeightList: [
        {
          mwT: "Method-1",
          mwV: "1",
        },
        {
          mwT: "Method-2",
          mwV: "2",
        },
      ],
      excelUpload: "",
      vgmModel: {
        ccVgmId: "",
        vgmWeight: "",
        ccImportId: this.$sessionsStorage.get("editCcImportId"),
        cctype: "Export",
        clientName: "",
        clientId: "",
        containerType: "",
        sizeTeu: "",
        ccContanerId: "",
        clientRegistrationNo: "",
        officialContactNo: "",
        nameRegistrationOfficial: "",
        containerNo: "",
        containerTypeId: "",
        maxPermissibleWeight: "",
        verifiedConGrossMass: "",
        weighingDate: "",
        weighingSlipNo: "",
        weighbridgeRegNo: "",
        weighbridgeAddress: "",
        additionalDetails: [],
      },

      errorVgmList: {
        clientRegistrationNo: "",
        officialContactNo: "",
        nameRegistrationOfficial: "",
        maxPermissibleWeight: "",
        verifiedConGrossMass: "",
        weighingDate: "",
        weighingSlipNo: "",
        weighbridgeRegNo: "",
        weighbridgeAddress: "",
        ccContanerId: "",
      },
      arrayErrorVgm: [
        "Enter regristration No",
        "Enter Contact no",
        "Enter name registration",
        "Enter max permissible weight",
        "Enter verified gross mass",
        "Select weighing Date",
        "Enter weighing slip no",
        "Enter weighbrigde registration No",
        "Enter weighbridge address",
        "Select Container No",
      ],

      removeVmodel: {
        weighingSlipNo: "",

        containerNo: "",
        containerTypeId: "",
        ccContanerId: "",
        ccVgmId: "",
      },
      vgmArrayList: [],
      CommodityAll: {},
      getCommodityData: ["zim"],
      ALLFclData: ["zim"],

      getContainerTypeData: ["zim"],
      validate: true,
      portCodeError: "",
      deleteId: "",
      ffExoprtDetail: {
        commodityId: "",
        IMDGClass: "",
        UNNumber: "",
        packingCode: "",
        commodityType: "",
        itemDescription: "",
      },
    };
  },

  filters: {
    moment(date) {
      return DateFormat(date)
    },
  },
  watch: {
    vgmModel: {
      handler: function (newVal, oldVal) {
        if (newVal.ccContanerId != "") {
          let arrayNewContainer = this.containerNoName.filter((x) => {
            return x.uniqueContainerId == newVal.ccContanerId;
          });
          if (arrayNewContainer.length > 0) {
            this.vgmModel.containerTypeId =
              arrayNewContainer[0].containerTypeId;
            this.vgmModel.containerType = arrayNewContainer[0].containerType;
          }
        }
        if (newVal.maxPermissibleWeight != "") {
          let vgmweight = parseFloat(newVal.vgmWeight);
          let maxPermis = parseFloat(newVal.maxPermissibleWeight);
          if (vgmweight > maxPermis) {
            this.alert.content =
              " VGM Weight Weight must be less than or equal to Max Permissible Weight ";
            this.$refs["addPopMaxPer"].open();
          }
        }
      },
      deep: true,
    },
  },
  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    BannerComponent
  },

  computed: {
    containerNoList() {
      return this.containerNoName;
    },
    ContainerTypeList() {
      return this.getContainerTypeData;
    },
    commodityList() {
      return this.getCommodityData;
    },
  },

  methods: {
    clearPermisibleWgt() {
      this.vgmModel.vgmWeight = "";
    },
    removeNotify(index) {
      this.vgmModel.additionalDetails.splice(index, 1);
      //  this.errorMultiContainer.splice(index, 1);
    },
    addAdditional() {
      let obj = {
        additionalLabel: "",
        additionalValue: "",
      };

      this.vgmModel.additionalDetails.push(obj);
    },
    doLoading() {
      this.isLoading = true;
      // simulate AJAX
    },
    doLoadingClose() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    Print(item) {
      window.open(
        `${this.docURL}/ASSIGNMENT_UPLOADS/` +
          this.ALLFclData[0].ccImportSeries.replaceAll("/", "_") +
          "/" +
          item
      );

      //window.open(`${this.docURL}/VGM_CCEXPORT_PDF/` + item);
    },
    viewEdit(item) {
      let arrayFilter = this.vgmArrayList.filter((x) => {
        return x.ccVgmId == item.ccVgmId;
      });

      Object.keys(this.vgmModel).map((x) => {
        if (x == "additionalDetails") {
          let array = item[x].split("$$$");

          array.map((y) => {
            let objVal = y.split("$-$");
            let obj = {
              additionalLabel: objVal[0],
              additionalValue: objVal[1],
            };

            this.vgmModel.additionalDetails.push(obj);
          });
        } else {
          this.vgmModel[x] = arrayFilter[0][x] || "";
        }
      });
    },
    getData() {
      this.isLoading = true;
      let type_Size = {
        itemCode: "itemCode",
        ccImportId: this.$sessionsStorage.get("editCcImportId"),
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Custom/fetchToCCExportVgm_NewV3.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            console.log(data);
            if (data.containerMaster.length > 0) {
              this.getContainerTypeData = data.containerMaster;
            } else {
              this.getContainerTypeData = [];
            }
            if (data.CommodityData.length > 0) {
              this.getCommodityData = data.CommodityData;
            } else {
              this.getCommodityData = [];
            }

            if (data.containerDetail.length > 0) {
              this.containerNoName = data.containerDetail;
            } else {
              this.containerNoName = [];
            }

            if (data.FullfclDetails.length > 0) {
              this.vgmModel.clientName = data.FullfclDetails[0].exporterName;
              this.vgmModel.clientId = data.FullfclDetails[0].exporterClientId;
              this.ALLFclData = data.FullfclDetails;
              Object.keys(this.ffExoprtDetail).map((x) => {
                this.ffExoprtDetail[x] = data.FullfclDetails[0][x] || "";
              });

              let item = this.getCommodityData.filter((x) => {
                return x.commodityId == data.FullfclDetails[0]["commodityId"];
              })[0];

              // this.ffExoprtDetail.commodityType = item.commodityType;
              // this.ffExoprtDetail.itemDescription = item.itemDescription;
            }

            if (data.vgmTableDetails.length > 0) {
              this.vgmArrayList = data.vgmTableDetails;

              Object.keys(this.vgmModel).map((x) => {
                if (x == "additionalDetails") {
                  this.vgmModel[x] = [];
                } else {
                  this.vgmModel[x] = data.vgmTableDetails[0][x] || "";
                }
              });

              Object.keys(this.removeVmodel).map((x) => {
                this.vgmModel[x] = "";
              });
            }
            this.isLoading = false;
            this.JqueryFun();
          }
        })
        .catch((error) => {});
    },
    CommodityCallback(item) {
      this.ffExoprtDetail.commodityId = item.commodityId;
      this.ffExoprtDetail.commodityType = item.commodityType;
      this.ffExoprtDetail.itemDescription = item.itemDescription;
    },
    JqueryFun() {
      return $(function () {
        return $("#portLocationNew").DataTable();
      });
    },

    previousSalesView() {
      window.history.go(-1);
      // this.$router.push({
      //   path: "/CCImport/ediExecution"
      // });
    },

    validateAddVehicleSizeForm() {
      let validate_new = true;
      if (this.vgmModel.portName == "") {
        $("#portName").focus();
        this.portNameError = "Enter Port Name";
        validate_new = false;
      }

      if (this.vgmModel.portCode == "") {
        $("#portCode").focus();
        this.portCodeError = "Enter Port Code ";
        validate_new = false;
      }

      if (this.vgmModel.portLocation == "") {
        $("#portLocation").focus();
        this.portLocationError = "Enter Port Location ";
        validate_new = false;
      }
      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    validateVGM() {
      let validate_new = true;
      Object.keys(this.errorVgmList).map((x, index) => {
        if (this.vgmModel[x] == "") {
          this.errorVgmList[x] = this.arrayErrorVgm[index];
          validate_new = false;
        }
      });
      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },

    addVGM() {
      this.vgmModel["salesSeries"] =
        this.ALLFclData[0].ccImportSeries.replaceAll("/", "_");
      this.vgmModel["allModuleId"] = this.ALLFclData[0].allModuleId;
      if (this.containerNoName.length > 0 && this.vgmModel.ccVgmId == "") {
        let arrayNew = this.containerNoName.filter((x) => {
          return x.uniqueContainerId == this.vgmModel.ccContanerId;
        });

        if (arrayNew.length > 0) {
          this.vgmModel.containerNo = arrayNew[0].containerNo;
        }
      }

      this.validateVGM();
      if (this.validate != false) {
        let newData = {
          vgmModel: this.vgmModel,
          ffExoprtDetail: this.ffExoprtDetail,
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Custom/addCCExVgm.php`,
          data: JSON.stringify(newData),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            if (result.data.Id != "" && result.data.Id != undefined) {
              if (this.vgmModel.ccVgmId != "") {
                this.alert.content = "Data updated Successfully";
              } else {
                this.alert.content = "Data Added Successfully";
              }

              Object.keys(this.removeVmodel).map((x) => {
                this.vgmModel[x] = "";
              });
              this.getData();

              this.$refs["addPop"].open();
            }
          })
          .catch((error) => {});
      }
    },
    deleteData(id) {
      this.deleteId = id;
      this.alert.content = "Are you sure you want to delete this item?";
      this.$refs["addPop6"].open();
    },

    onClose(type) {},
  },
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// newCCExVgm.vue?c0f8fd34